module.exports = __webpack_public_path__ + "img/hao.2a8e8cb9.png";